document.addEventListener("DOMContentLoaded", () => {
      //<![CDATA[
        let acc_btns = document.getElementsByClassName("custom-accordion_button");
        let contentDiv = document.getElementsByClassName("custom-accordion_content");
        let icon_index = -1;
        let cnt = 0;
  
        $('.custom-accordion_button').on('click', function() {
            $(".accordions").find(".icon").removeClass("active");
            if($(this).parents(".accordion-item").index() == icon_index && cnt == 1) {
                cnt  = 0;
                return;
            }
            if($(this).find(".icon").hasClass("active")) {
                cnt = 0;
                $(".accordions").find(".icon").removeClass("active");
            }else {
                cnt = 1;
                $(this).find(".icon").addClass("active");
            }
            icon_index = $(this).parents(".accordion-item").index();
        });


        let cnt1 = 0;
        let item_index1 = -1;
        for (let i = 0; i < acc_btns.length; i++) {
            acc_btns[i].addEventListener("click", function() {      
                if (parseInt(contentDiv[i].style.height) != contentDiv[i].scrollHeight) {
                    contentDiv[i].style.height = contentDiv[i].scrollHeight + "px";
                } else {
                    contentDiv[i].style.height = "0px";
                }

                for (let j = 0; j < contentDiv.length; j++) {
                    if (j !== i) {
                        contentDiv[j].style.height = 0;
                    }
                    acc_btns[j].classList.remove('is-active');
                }

                if(i == item_index1 && cnt1 == 1) {
                  cnt1  = 0;
                  return;
                }
                if(this.classList.contains("is-active")) {
                  cnt1 = 0;
                  this.classList.remove('is-active');
                }else {
                  cnt1 = 1;
                  this.classList.add('is-active');
                }
                item_index1 = i;
            });
        }

})